import { observable, makeObservable } from 'mobx'
import { Permission, PermissionDescriptionDTO } from '../dtos/permissions'
import { Model } from 'infra/model'

export default class PermissionDescription extends Model<
  PermissionDescriptionDTO,
  PermissionDescription
> {
  @observable name = ''
  @observable description = ''
  @observable id: Permission = 'UNKNOWN'

  constructor() {
    super()

    makeObservable(this)
  }

  parse(
    attrs: Partial<PermissionDescriptionDTO>,
  ): Partial<PermissionDescription> {
    return {
      description: attrs.description,
      id: attrs.id,
      name: attrs.name,
    }
  }
}
